import { render } from "./UserManagementJobAssignmentDialog.vue?vue&type=template&id=470e9fa8"
import script from "./js/userManagementJobAssignmentDialog.js?vue&type=script&lang=js&external"
export * from "./js/userManagementJobAssignmentDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__